
import {Component, Prop} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import SelectRef from '@/components/common/SelectRef.vue'
import RadioGroupYesNo from '@/components/common/RadioGroupYesNo.vue'
import SelectConseiller from '@/components/common/SelectConseiller.vue'
import ProspectFastModel from '@/models/ProspectFastModel'
import convertDateDirective from '@/directives/convertDateDirective'
import convertAmountDirective from '@/directives/convertAmountDirective'
import convertTelNumberDirective from '@/directives/convertTelNumberDirective'
import {isCoprolibTelNumber} from '@/helpers/validators'
import {FaRating} from 'vue-rate-it'
import ThumbsUp from 'vue-rate-it/glyphs/thumbs-up'
import {required, requiredIf, email} from 'vuelidate/lib/validators'

@Component({
  components: {
    BaseFormContainer,
    SelectRef,
    RadioGroupYesNo,
    SelectConseiller,
    FaRating
  },
  directives: {
    convertDateDirective,
    convertAmountDirective,
    convertTelNumberDirective
  },
  validations: {
    form: {
      CODE_REF_CIVILITE: {
        required
      },
      CODE_REF_DEPARTEMENT: {
        required
      },
      NOM: {
        required
      },
      EMAIL: {
        required: requiredIf((form) => {
          return !form.TELEPHONE1
        }),
        email
      },
      ADRESSE: {
        required
      },
      NOMBRE_LOTS_PRINCIPAUX: {
        required
      },
      TELEPHONE1: {
        required: requiredIf((form) => {
          return !form.EMAIL
        }),
        isCoprolibTelNumber
      }
    }
  }
})
export default class ProspectFastForm extends BaseForm {
  @Prop() version!: string
  model = ProspectFastModel
  resetForm() {
    this.$v.form.$reset()
    this.resetHandler()
  }
}
